export default __webpack_public_path__ + "static/media/tatoo-master.01614ae7.jpg";